module.exports = __webpack_public_path__ + "img/ppt_2x.1e9b8c89.svg";